<template>
  <div class="lg:grid lg:grid-cols-3 gap-[25px]">
    <div class="lg:col-span-3">
      <CalendarContent @event-click="openEditEventModal" @edit-working-hours="openWorkingHoursModal" />
    </div>
  </div>
  <AddEventModal />
  <EditEventModal ref="editEventModalRef" />
  <EditWorkingHoursModal :is-active="showWorkingHoursModal" @close="closeWorkingHoursModal" />
</template>

<script setup lang="ts">
import { ref } from "vue";
import CalendarContent from "@/components/Apps/Calendar/CalendarContent.vue";
import AddEventModal from "@/components/Apps/Calendar/AddEventModal.vue";
import EditEventModal from "@/components/Apps/Calendar/EditEventModal.vue";
import EditWorkingHoursModal from "@/components/Apps/Calendar/EditWorkingHoursModal.vue";

const editEventModalRef = ref<any>(null);
const showWorkingHoursModal = ref(false);

function openEditEventModal(event: any) {
  if (editEventModalRef.value) {
    editEventModalRef.value.openModal(event);
  }
}

function openWorkingHoursModal() {
  showWorkingHoursModal.value = true;
}

function closeWorkingHoursModal() {
  showWorkingHoursModal.value = false;
}
</script>
